// extracted by mini-css-extract-plugin
export default {"Container":"GeneralItemStyles__Container__2ZIGm","DeleteBtn":"GeneralItemStyles__DeleteBtn__3jN-r","Deleting":"GeneralItemStyles__Deleting__3DJGl"};